import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import WarningOutlinedIcon from "@mui/icons-material/WarningOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useStyles } from "./styles";
import AlertLink from "./AlertLink";

export const alertTypes = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
};

const backgroundColor = {
  error: alertTypes.ERROR,
  success: alertTypes.SUCCESS,
  warning: alertTypes.WARNING,
  info: alertTypes.INFO,
};

const Icons = {
  error: ErrorIcon,
  success: CheckCircleIcon,
  warning: WarningOutlinedIcon,
  info: InfoOutlinedIcon,
};

const AlertBox = React.memo(({ classes,customIcon,withIcon=false, message, type, link,className='' }) => {
  if (message) {
    const Icon = customIcon || Icons[type]
    return (
      <p className={clsx(classes.messageBox, classes[backgroundColor[type]],className)}>
        {withIcon && <span className="icon"><Icon/></span>} <span className="message">{message}</span> <AlertLink link={link} />
      </p>
    );
  }
  return null;
});

AlertBox.propTypes = {
  type: PropTypes.oneOf(["error", "success", "warning", "info"]),
  message: PropTypes.string,
};

AlertBox.defaultProps = {
  type: "error",
};

export default withStyles(useStyles)(AlertBox);
